module.exports = __webpack_public_path__ + "static/img/inbody.f08e4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/inbody.png
// module id = PttI
// module chunks = 1